'use client'

import React from 'react';
import styled from 'styled-components';
import {
  Home,
  Group,
  LocalFlorist,
  AccessAlarm,
  Settings,
  Shield,
} from '@mui/icons-material';  // <-- Updated imports from MUI icons
import { useSelector } from 'react-redux';

const DynamicCard = ({ icon: IconComponent, title, description }) => {
  return (
    <StyledWrapper>
      <div className="card">
        <div className="card2">
          <div className="content">
            <div className="iconWrapper">
              {/* Dynamic Icon Rendering */}
              <span className="icon">
                {IconComponent ? <IconComponent style={{ fontSize: 40 }} /> : <Home style={{ fontSize: 40 }} />}
              </span>
            </div>
            <h5 className="text">{title}</h5>
            <p className="description">{description}</p>
          </div>
        </div>
      </div>
    </StyledWrapper>
  );
};

const CardStylist = () => {
  const language = useSelector((state) => state.language.language);

  const text = {
    cardFirstTitle: language === "en" ? "Luxury Experience" : "विलासिता का अनुभव",
    cardFirstDescription: language === "en"
      ? "Enjoy premium salon services at home with top-notch beauty treatments and pampering brought to your doorstep in Noida."
      : "नोएडा में हमारे लक्ज़री होम सैलून सेवा से आपके दरवाजे पर बेहतरीन ब्यूटी ट्रीटमेंट्स और पैंपरिंग का अनुभव लें।",
    cardSecondTitle: language === "en" ? "Expert Professionals" : "विशेषज्ञ पेशेवर",
    cardSecondDescription: language === "en"
      ? "Our trained beauty professionals ensure personalized treatments with exceptional service tailored to your needs."
      : "हमारे प्रशिक्षित ब्यूटी प्रोफेशनल्स आपकी आवश्यकताओं के अनुसार व्यक्तिगत ट्रीटमेंट्स प्रदान करते हैं।",
    cardThirdTitle: language === "en" ? "High-Quality Products" : "उच्च गुणवत्ता वाले उत्पाद",
    cardThirdDescription: language === "en"
      ? "We use premium salon-grade products to ensure safe, effective treatments for your hair and skin."
      : "हम केवल बेहतरीन सैलून-ग्रेड उत्पादों का उपयोग करते हैं, ताकि आपके बालों और त्वचा के लिए सुरक्षित और प्रभावी ट्रीटमेंट्स सुनिश्चित हों।",
    cardFourthTitle: language === "en" ? "Convenience and Flexibility" : "सुविधा और लचीलापन",
    cardFourthDescription: language === "en"
      ? "Our flexible scheduling makes booking appointments easier, letting you enjoy beauty care with convenience."
      : "हमारी लचीली योजना आपको सुविधाजनक अपॉइंटमेंट बुकिंग का विकल्प देती है।",
    cardFifthTitle: language === "en" ? "Customized Services" : "अनुकूलित सेवाएं",
    cardFifthDescription: language === "en"
      ? "Our services are tailored to your unique preferences, ensuring a personalized experience with every treatment."
      : "हमारी सेवाएं आपकी विशेष पसंद के अनुसार अनुकूलित की जाती हैं, ताकि हर ट्रीटमेंट का अनुभव व्यक्तिगत हो।",
    cardSixthTitle: language === "en" ? "Hygiene and Safety" : "स्वच्छता और सुरक्षा",
    cardSixthDescription: language === "en"
      ? "We follow the highest hygiene standards, ensuring sanitized tools and a safe experience."
      : "हम उच्चतम स्वच्छता मानकों का पालन करते हैं, ताकि आपको सुरक्षित और शांति से सेवा मिल सके।",
    whyChooseUsTitle: language === "en" ? "Why Choose Us" : "हमसे क्यों चुनें",
    whyChooseUsDescription: language === "en"
      ? "We offer a blend of convenience, expertise, and quality that ensures a premium beauty experience at your doorstep."
      : "हम एक बेहतरीन सुंदरता अनुभव के लिए सुविधा, विशेषज्ञता और गुणवत्ता का संयोजन प्रदान करते हैं, जो आपके दरवाजे तक पहुंचता है।"
  };

  return (
    <>
      <div style={{ marginTop: '-110px' }}>
        <div className="">
          <div className="max-w-screen-2xl mx-auto lg:py-20 py-10 px-4 sm:px-10">
            <div className="mb-10 flex justify-center">
              <div className="text-center w-full lg:w-4/5">
                <h2
                  style={{
                    fontSize: '1.4rem',
                    color: '#000000', /* Black text color */
                    fontFamily: 'Roboto, sans-serif',
                  }}
                  className="text-xl lg:text-2xl mb-2 font-semibold"
                >
                  {text.whyChooseUsTitle}
                </h2>
                <p className="text-base font-sans text-gray-600 leading-6 justify-center">
                  {/* Description text can go here */}
                </p>
              </div>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-4 gap-6 xl:gap-8 mt-[-20px]">
              <DynamicCard icon={Home} title={text.cardFirstTitle} description={text.cardFirstDescription} />
              <DynamicCard icon={Group} title={text.cardSecondTitle} description={text.cardSecondDescription} />
              <DynamicCard icon={LocalFlorist} title={text.cardThirdTitle} description={text.cardThirdDescription} />
              <DynamicCard icon={AccessAlarm} title={text.cardFourthTitle} description={text.cardFourthDescription} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const StyledWrapper = styled.div`
  .card {
    width: 100%;
    height: 254px;
    background-color: #ffffff;  /* White background for card */
    border-radius: 20px;
    transition: all 0.3s;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: 'Roboto', sans-serif;
  }

  .card2 {
    width: 100%;
    height: 244px;
    background-color: #ffffff;  /* White background for card2 */
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    padding: 10px;
    box-sizing: border-box;
  }

  .content {
    text-align: center;
    padding: 20px;
  }

  .iconWrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 10px;
  }

  .icon {
    font-size: 2.5em;
    color: #fbbf24;  /* Yellow icon color */
  }

  .text {
    font-size: 1.25rem;
    color: #000000;  /* Black text color */
    font-weight: bold;
    margin-bottom: 10px;
  }

  .description {
    font-size: 1rem;
    color: black;  /* Black description color */
    opacity: 0.9;
    line-height: 1.75;
  }
`;

export default CardStylist;
